/*
 * sign-rail.js — play the inline homepage sign-nav reveal when it scrolls in.
 * ---------------------------------------------------------------------------
 * The sign-rail sits below the fold on mobile (under the CTA), so a plain
 * on-load CSS reveal would finish off-screen before it's ever seen. This adds
 * `.is-inview` when the nav scrolls into view; the CSS animation is gated on
 * that class so the signs unfold as you reach them.
 *
 * Bulletproof by design: the signs are VISIBLE BY DEFAULT in the CSS, and the
 * reveal only ENHANCES them. So if this script never runs, there's no
 * IntersectionObserver, or anything throws — the nav simply shows statically,
 * never stuck hidden. Reduced-motion is left untouched (the CSS skips the
 * animation there anyway).
 */
(function () {
  var rails = document.querySelectorAll('.sign-rail--reveal');
  if (!rails.length) return;

  if (
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return; // signs stay visible/static; nothing to animate
  }

  var reveal = function (el) {
    el.classList.add('is-inview');
  };

  // No IntersectionObserver: reveal them all now (still a clean reveal for
  // anything in view; below-fold ones just play early — better than never).
  if (!('IntersectionObserver' in window)) {
    rails.forEach(reveal);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        obs.unobserve(entry.target);
      });
    },
    // Fire a touch before it's fully in view so the unfold starts as it enters.
    { rootMargin: '0px 0px -10% 0px', threshold: 0.01 }
  );

  rails.forEach(function (rail) {
    observer.observe(rail);
  });
})();
